import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function TransitionBlock() {
  return <section className="py-24 md:py-32 px-6 bg-nude-light" data-id="element-311">
      <div className="max-w-3xl mx-auto text-center" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-313">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold mb-6 block" data-id="element-314">
            Tu Rutina, Simplificada
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-luxury-black leading-tight mb-8" data-id="element-315">
            TODO LO QUE NECESITAS, <br className="hidden md:block" data-id="element-316" />
            <span className="italic text-gray-500" data-id="element-317">EN UN SOLO KIT</span>
          </h2>

          <div className="space-y-4 text-gray-600 font-sans font-light text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-318">
            <p data-id="element-319">Olvídate de buscar, mezclar o improvisar.</p>
            <p data-id="element-320">
              Cada detalle fue pensado para que tengas a la mano lo esencial
              para verte profesional, organizada y segura… en cualquier momento.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto mb-14" data-id="element-321">
            {['Organización total en segundos', 'Diseño elegante y profesional', 'Ideal para uso diario o trabajo', 'Perfecto para llevar contigo a cualquier lugar'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * i
          }} className="flex items-center gap-3 text-sm text-gray-700" data-id="element-322">
                <Check className="w-4 h-4 text-gold shrink-0" data-id="element-323" />
                <span data-id="element-324">{item}</span>
              </motion.div>)}
          </div>

          <div className="mb-14" data-id="element-325">
            <div className="w-10 h-0.5 bg-gold mx-auto mb-8" data-id="element-326"></div>
            <p className="font-serif text-2xl md:text-3xl italic text-luxury-black" data-id="element-327">
              Menos complicaciones. Más confianza.
            </p>
            <div className="w-10 h-0.5 bg-gold mx-auto mt-8" data-id="element-328"></div>
          </div>

          <p className="text-sm tracking-[0.2em] uppercase text-gray-400 font-medium" data-id="element-329">
            Elige el que mejor va contigo ↓
          </p>
        </motion.div>
      </div>
    </section>;
}